export const SUCCESSFUL_GET_PAYMENTPLAN  = "SUCCESSFUL_GET_PAYMENTPLAN";
export const UPDATE_SALEORDER  = "UPDATE_SALEORDER";


// WEBPACK FOOTER //
// ./src/reducers/paymentplan/actionConst.js